import React from 'react';
import { IRelationshipRankingsType } from '../actions/StatsActions';
import ToggleableChordDiagramChart from './charts/ToggleableChordDiagram';

export interface IRelationshipLeaderboardProps {
  id: string;
  title: string;
  data: Array<IRelationshipRankingsType>;
}

const RelationshipLeaderboard: React.FC<IRelationshipLeaderboardProps> = (props: IRelationshipLeaderboardProps) => {
    return (
      <div className="RelationshipLeaderboard">
        <p className="LeaderboardCenteredTitle">{props.title}</p>
        <ToggleableChordDiagramChart id="WorldRecordTradesToggleableChordDiagramChart" data={props.data} />
      </div>
    );
  }
  
  export default RelationshipLeaderboard;